import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarrierPerfCalculationCleanup extends Layout {
    labelCalculationCount: Label;
    labelSuffix: Label;
    sourceCarrierPerfCalculations: DataSource;
    tableCarrierPerfCalculations: Table;
}
